// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How use it:
 * 1. by dispatch:
 *      dispatch({ type: "xCommon/update", data: { key: "isTabletScreen", value: true } });
 *      data => it has "key" -> object key and value
 * 2. by handler:
 *      xCommonUpdate({ key: "isTabletScreen", value: true });
 */

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export type xCommonHandlerType = { key?: string; value: any };

export const DispatchUpdateXCommon: Handler<xCommonHandlerType> = props => {
    props.dispatch({
        type: "xCommon/update",
        data: props.parameter,
    } as any);
};

const xCommonUpdate = createHandlerChainRunner([DispatchUpdateXCommon], "xCommonUpdate");
export { xCommonUpdate };

export const DispatchUpdateXLoadingOverlay: Handler<xCommonHandlerType> = props => {
    props.dispatch({
        type: "xCommon/loadingOverlay",
        data: props.parameter,
    } as any);
};

const xCommonLoadingOverlay = createHandlerChainRunner([DispatchUpdateXLoadingOverlay], "xCommonLoadingOverlay");
export { xCommonLoadingOverlay };

type xTabEnableZoneHandlerType = { zone?: string; isEnabled?: boolean };

export const DispatchXTabEnableZone: Handler<xTabEnableZoneHandlerType> = props => {
    props.dispatch({
        type: "xTabs/EnableZone",
        data: props.parameter,
    } as any);
};

const xTabEnableZone = createHandlerChainRunner([DispatchXTabEnableZone], "xTabEnableZone");
export { xTabEnableZone };

